import { ClientResponseError } from 'pocketbase'
import { toast } from 'sonner'

export function handleServerError(error: unknown) {
  // eslint-disable-next-line no-console
  console.log(error)

  let errMsg = 'Something went wrong!'

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number(error.status) === 204
  ) {
    errMsg = 'Content not found.'
  }

  if (error instanceof ClientResponseError) {
    toast.error(error.response?.message ?? 'No title', {
      description: JSON.stringify(error.response),
      testId: 'server-error-toast',
    })
  } else {
    toast.error(errMsg, {
      description: (
        <pre className='mt-2 w-full overflow-x-auto rounded-md bg-slate-950 p-4'>
          <code className='text-white'>{JSON.stringify(error, null, 2)}</code>
        </pre>
      ),
      testId: 'server-error-toast',
      duration: 7000,
    })
  }
}
